import { render, staticRenderFns } from "./SettingsForYouTube.vue?vue&type=template&id=550243e6&scoped=true&"
import script from "./SettingsForYouTube.vue?vue&type=script&lang=js&"
export * from "./SettingsForYouTube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550243e6",
  null
  
)

export default component.exports